import { createSlice } from '@reduxjs/toolkit';

// User creation is now handled by authSlice.registerUser
// This slice can be used for other user-related state if needed

interface UserState {
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetUserState: (state) => {
      state.loading = false;
      state.error = null;
    },
    setUserLoading: (state, action) => {
      state.loading = action.payload;
    },
    setUserError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { resetUserState, setUserLoading, setUserError } = userSlice.actions;
export default userSlice.reducer;
